import { User } from "@ecologi/shared";
import PlusIconSvg from "@ecologi/assets/icons/plus-icon.svg";
import React, { useState } from "react";
import styled from "@emotion/styled";
import { ReferralModal, ReferralModalVariants } from "../ReferralModal";
import {
  ForestTile,
  ForestTileInner,
  ForestTileSparkles,
  ForestTileStack,
  ForestTileStackPost,
} from "../ForestTile";

export type ForestTileReferralProps = {
  profile: User;
  user: User | null;
  isForestEmpty?: boolean;
};

const referralTileTextOptions = [
  "Sparkly trees",
  "Referral code",
  "Invite friends",
];

const referralTileText =
  referralTileTextOptions[
    Math.floor(Math.random() * referralTileTextOptions.length)
  ];

const ReferralTileSparkles = styled(ForestTileSparkles)`
  width: 109px;
`;

const PlusIcon = styled(PlusIconSvg)`
  fill: ${(props) => props.theme.colors.snowdrop};
  left: 50%;

  width: 10px;
  height: 10px;
  position: absolute;
  top: 5px;
  transform: translateX(-50%);

  @media ${(props) => props.theme.bp.tabletUp} {
    top: 9px;
    width: 12px;
    height: 12px;
  }
`;

export const ForestTileReferral = ({
  profile,
  user,
  isForestEmpty,
}: ForestTileReferralProps) => {
  const [isReferralModalVisible, setIsReferralModalVisible] = useState(false);

  const referralLink = `https://ecologi.com${profile.getProfilePath()}?direct=true&r=${
    user?.userId || profile?.userId
  }`;

  return (
    <>
      <ForestTile
        id="tour-referral"
        title="Refer a friend to Ecologi"
        onClick={() => {
          setIsReferralModalVisible(true);
        }}
        $isForestEmpty={isForestEmpty}
      >
        <ForestTileInner>
          <ReferralTileSparkles isSingle />
          <ForestTileStackPost value={referralTileText} isCentered />
          <ForestTileStack>
            <PlusIcon />
          </ForestTileStack>
        </ForestTileInner>
      </ForestTile>

      <ReferralModal
        variant={
          profile.isBusinessType
            ? ReferralModalVariants.B2B
            : ReferralModalVariants.CONSUMER
        }
        isOpen={isReferralModalVisible}
        referralLink={referralLink}
        onClose={() => setIsReferralModalVisible(false)}
      />
    </>
  );
};
